module.exports = __webpack_public_path__ + "fonts/ArbFONTS-DINNextLTArabic-Regular.61b1e04f.ttf";